/*
 * Module for the topic Categories.
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesView",
  "./topicCategoriesModel",
], function (Marionette, _, Messenger, TopicCategoriesView, TopicCategoriesModel) {
  var TopicCategoriesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicCategories";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (categories, categoryIdToFocus) {
      this.categories = categories;
      this.categoryIdToFocus = categoryIdToFocus;

      categories.allowDeleteCategoryCodes = Messenger.reqres.request(
        "can:delete:topicCategoryCodes",
      );
      categories.allowEditCategoryCodes = Messenger.reqres.request("can:edit:topicCategoryCodes");

      this.categories.onSynced(function () {
        var map = new Map();
        var keys = [];
        this.categories.forEach(function (cat) {
          if (map.has(cat.get("categoryId"))) {
          } else {
            keys.push(parseInt(cat.get("categoryId")));
            map.set(parseInt(cat.get("categoryId")), {
              categoryId: cat.get("categoryId"),
              categoryName: cat.get("categoryName"),
              description: cat.get("categoryDescription"),
              categoryValues: [],
            });
          }
        });
        // 2nd loop map categories values
        this.categories.forEach(function (cat) {
          if (map.has(parseInt(cat.get("categoryId")))) {
            map.get(parseInt(cat.get("categoryId"))).categoryValues.push({
              categoryValueId: cat.get("categoryValueId"),
              categoryId: cat.get("categoryId"),
              value: cat.get("categoryValue"),
              categoryName: cat.get("categoryName"),
              description: cat.get("categoryValueDescription"),
            });
          }
        });

        this.filteredCategories = new TopicCategoriesModel.topicCategoriesBk();
        this.filteredCategories.allowDeleteCategoryCodes = categories.allowDeleteCategoryCodes;
        this.filteredCategories.allowEditCategoryCodes = categories.allowEditCategoryCodes;

        keys.forEach(function (key) {
          var model = new TopicCategoriesModel.topicCategoryBk({
            categoryId: map.get(key).categoryId,
            categoryName: map.get(key).categoryName,
            description: map.get(key).description,
          });
          var categoryValues = new TopicCategoriesModel.topicCategoryValues(
            map.get(key).categoryValues,
          );
          categoryValues.allowDeleteCategoryCodes = categories.allowDeleteCategoryCodes;
          categoryValues.allowEditCategoryCodes = categories.allowEditCategoryCodes;
          categoryValues.sort();
          model.set("categoryValues", categoryValues);
          this.filteredCategories.add(model);
        }, this);

        this.view = new TopicCategoriesView.accordionView({
          collection: this.filteredCategories,
          focusedCategory: this.categoryIdToFocus,
        });

        this.view.on(
          "show",
          function () {
            if (this.categoryIdToFocus !== undefined) {
              this.view.scrollToCategory(this.categoryIdToFocus);
            }
          },
          this,
        );

        //Sort the categories
        // categories.sort();
        this.showRegion(this.view, { loading: true, entity: this.filteredCategories });
      }, this);
    },

    _setUpVents: function () {
      //event when the a node from the conversation diagram is selected
      Messenger.vent.on(
        "topic:category:list:refresh",
        function (cats) {
          this.show(cats);
        },
        this,
      );

      Messenger.vent.on(
        "topic:category:list:refreshOnSave",
        function () {
          // if handler available, use it.
          try {
            var conversationNode = Messenger.reqres.request("get:response:conversationNode");
            this.show(conversationNode.categories());
          } catch (err) {}
        },
        this,
      );

      Messenger.vent.on(
        "topic:category:list:delete:categoryValue",
        function (categoryValue) {
          Messenger.yesNoDialog(
            "topic.categories.deleteDialog",
            {
              yes: function () {
                const modelToDelete = this.categories.findWhere({
                  categoryValueId: categoryValue.get("categoryValueId"),
                });
                const topicId = Messenger.reqres.request("current:topic:id");
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Topic Category",
                  id: [topicId, modelToDelete.id],
                  idType: ["Topic", "Topic Category"],
                  object: "Topic Category",
                });
                modelToDelete.deleteModel();
                this.show(this.categories, categoryValue.get("categoryId"));
              },
            },
            this,
          );
        },
        this,
      );
    },
  });

  return TopicCategoriesController;
});
